import { endorsementsMap } from '../Components/AddOns/addOnQuestionMap';
import { isObjectLiteral } from './functionalHelpers';

const checkAddons = (
  availableEndorsements: AvailableEndorsementsState,
  endorsementsState: EndorsementsInterface | undefined,
  shouldValidate: (params: {
    hasValidationQuestions: boolean;
    hasUnderwritingQuestions: boolean;
    questionMarkedYes: boolean;
  }) => boolean
): boolean => {
  if (!availableEndorsements) return false;

  return Object.keys(availableEndorsements).every((endorsementKey) => {
    const endorsementConfig = endorsementsMap[endorsementKey];
    if (!endorsementConfig) return true;

    const questionData = endorsementsState?.[endorsementKey];
    const questionMarkedYes = isObjectLiteral(questionData);

    const underwritingSubQuestions = endorsementConfig?.subQuestions?.underwritingQuestions;
    const validationQuestions = endorsementConfig?.subQuestions?.validation?.validationQuestions;

    const hasUnderwritingQuestions = !!underwritingSubQuestions;
    const hasValidationQuestions = !!validationQuestions;

    if (hasUnderwritingQuestions && questionMarkedYes) {
      return Object.keys(underwritingSubQuestions).every((subQuestionKey) => questionData?.[subQuestionKey] != null);
    }

    if (hasValidationQuestions && questionMarkedYes) {
      return shouldValidate({ hasValidationQuestions, hasUnderwritingQuestions, questionMarkedYes })
        ? Boolean(Object.keys(questionData ?? {}).length)
        : true;
    }

    return true;
  });
};

const checkIfAddonsAreComplete = (
  availableEndorsements: AvailableEndorsementsState,
  endorsementsState?: EndorsementsInterface
) => checkAddons(availableEndorsements, endorsementsState, () => true);

export const checkIfAddonsAreRateable = (
  availableEndorsements: AvailableEndorsementsState,
  endorsementsState?: EndorsementsInterface
) => checkAddons(availableEndorsements, endorsementsState, ({ hasValidationQuestions }) => !hasValidationQuestions);

export default checkIfAddonsAreComplete;
